import loadReactionValues from './loadReactionValues'
import loadActionSlots from './loadActionSlots'
import store from '../store/index'

//-----------------------
// load campaign round slots (get & load re/actions/markers)
//-----------------------
export default async function loadCampaignRoundSlots(round) {
  console.log('-------------------------')
  console.log('IN loadCampaignRoundSlots')
  return new Promise((resolve, reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store
    const this_store_state = store.state.combat
    //----------
    // set parm
    //----------
    let parm = {
      slug: this_store_state.arena.slug,
      round: round,
    }
    // console.log("off to combat/loadCampaignRoundActions...");
    //-----------------------
    // get actions for round
    //-----------------------
    this_store
      .dispatch('combat/loadCampaignRoundActions', parm)
      //---------------------------------
      // successful - load action values
      //---------------------------------
      .then((actions) => {
        // console.log("back from combat/loadCampaignRoundActions with actions");
        // console.log("action cnt = " + actions.length);
        //-------------------------
        // get reactions for round
        //-------------------------
        this_store
          .dispatch('combat/loadCampaignRoundReactions', parm)
          //-----------------------------------
          // successful - load reaction values
          //-----------------------------------
          .then((reactions) => {
            // console.log(
            //   "back from combat/loadCampaignRoundReactions with reactions"
            // );
            console.log('off to loadReactionValues... reactions cnt = ' + reactions.length)
            loadReactionValues(reactions)
            //-----------------------
            // get markers for round
            //-----------------------
            this_store
              .dispatch('combat/loadCampaignRoundMarkers', parm)
              //--------------------------------
              // successful - load action slots
              //--------------------------------
              .then((markers) => {
                // console.log(
                //   "back from combat/loadCampaignRoundMarkers with markers"
                // );
                loadActionSlots(round, actions, markers)
                //---------------------------
                // return updated combatants
                //---------------------------
                resolve(this_store_state.arena.arena_combatants)
              })
              //--------------
              // marker error
              //--------------
              .catch((err) => {
                reject(err)
              })
          })
          //----------------
          // reaction error
          //----------------
          .catch((err) => {
            reject(err)
          })
      })
      //--------------
      // action error
      //--------------
      .catch((err) => {
        reject(err)
      })
  })
}
